import request from '@/request'

export async function getAllPlans() {
  const response = await request({
    url: `/plans`,
    method: 'get'
  })

  return response.data
}

export async function getPlan (id) {
  const response = await request({
    url: `/plans/${id}`,
    method: 'get'
  })

  return response.data
}

export async function getPlanDefault () {
  const response = await request({
    url: `/plans?default=1`,
    method: 'get'
  })

  return response.data
}
